<template>
  <slot :isAllowed="isAllowed"></slot>
</template>

<script lang="ts">
import type { Action, Resource } from "../authorisation.types";

interface Props {
  action: Action;
  resource: Resource;
}
</script>

<script setup lang="ts">
import { computed, toRefs } from "vue";

import { useAuthorisation } from "../authorisation.composables.ts";

const props = defineProps<Props>();
const { action, resource } = toRefs(props);

const { hasPermission } = useAuthorisation();
const isAllowed = computed(() => hasPermission(action.value, resource.value));
</script>
